import React from 'react';
import { Page } from '../Page';
import { Dumbbell, Shield, Award } from 'lucide-react';
export function SupplementCreatine() {
  return <Page pageNumber={27} variant="light" data-id="element-3082" data-mp="20j3mgeyhvttd">
      <div className="flex h-full gap-10" data-id="element-3083" data-mp="1mi0y1vk127fa">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-3084" data-mp="1mk3xt7azfex7">
          <img src="https://cdn.magicpatterns.com/uploads/kEu8GqakDxEz3D2wvQLn1t/pasted-image.png" alt="Thorne Creatine" className="w-full max-w-[280px] object-contain" data-id="element-3085" data-mp="1rh451ljkinpw" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-3086" data-mp="25hexgt0j0ad6">
          <div className="mb-6 pt-4" data-id="element-3087" data-mp="25eizx5slbnp9">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3088" data-mp="2af6mnf9sdido">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3089" data-mp="2y3zmvnxfyce3">
              Creatine
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3090" data-mp="32xu6krd1qrd6">
              Protect your muscle while losing fat
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-3091" data-mp="2xevjec1jhhwr" />
          </div>

          <div className="mb-8" data-id="element-3092" data-mp="3b58nu4f82ehc">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-3093" data-mp="3b6inuz5mxwqm">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-3094" data-mp="36cxop3sb2wpu">
              The #1 concern with GLP-1 weight loss is muscle loss, with up to
              30-40% of weight lost can be lean mass. Creatine is one of the
              most evidence-backed supplements for preserving and building lean
              body mass, and it supports the exercise capacity needed to
              counteract muscle loss during caloric deficit.
            </p>
          </div>

          <div className="mb-8" data-id="element-3095" data-mp="1zqu045kk4tor">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-3096" data-mp="1voqcyjoj00nn">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-3097" data-mp="3utqdwhuqecsg">
              <li className="flex gap-2" data-id="element-3098" data-mp="3uvuspuu64w7i">
                <Dumbbell className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3099" data-mp="3mdya79hy7en" />
                <span data-id="element-3100" data-mp="8mjqppnlbxxs">
                  Preserves lean body mass during rapid weight loss and supports
                  strength
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3101" data-mp="djaaoo2indoh">
                <Shield className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3102" data-mp="hnqdgggu24zh" />
                <span data-id="element-3103" data-mp="mlruywym1w8u">
                  Supports exercise capacity when energy intake is reduced
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3104" data-mp="re2uhypfvg0v">
                <span className="text-tealslate shrink-0" data-id="element-3105" data-mp="rf47w9txgelr">•</span>
                <span data-id="element-3106" data-mp="wbbe83q8js48">
                  Helps prevent muscle cramps and dehydration (common GLP-1 side
                  effects)
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3107" data-mp="15brhbc32gx8k">
                <Award className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3108" data-mp="15csupn7k1vtg" />
                <span data-id="element-3109" data-mp="2pvd0ctevzaw3">
                  Micronized creatine monohydrate, easy to mix, no taste/odor,
                  NSF Certified for Sport
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-3110" data-mp="2gu5h9ikxygml">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-3111" data-mp="2bv293p9nzuae">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3112" data-mp="2bwwt91d43idf">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-3113" data-mp="34iy5stz8hm76">
                <strong data-id="element-3114" data-mp="34lkkddkjl1yw">1 scoop (5g) daily</strong>. Mix with water or add to
                protein shake
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-3115" data-mp="2uty2iydp84n6">
                450g tub (~90 servings) • Can be taken any time of day
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-3116" data-mp="3sad9aq2qy9k0">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3117" data-mp="3nhu005b3e0l0" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3118" data-mp="3c38rvo7owz9q">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}